import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Zoom from 'react-reveal/Zoom';

import HealthImg from '../../static/img/home_page/health_somatic_yoga_online.webp';
import CommunityImg from '../../static/img/home_page/community_mind_body_fitness.webp';
import MembershipImg from '../../static/img/home_page/membership_mind_body_fitness_classes.webp';

const styles = theme => ({
  section: {
    width: '100%',
    backgroundColor: '#EEEEEE',
    position: 'relative',
    padding: theme.spacing(3),
    paddingTop: theme.spacing(12),
    paddingBottom: theme.spacing(12),
    margin: '0 auto',
  },
  content: {
    width: '100%',
    [theme.breakpoints.up(900)]: {
      width: '900px',
    },
    margin: '0 auto',
    paddingBottom: theme.spacing(4),
  },
  icon: {
    width: 'auto',
    height: '270px',
    textAlign: 'center',
    margin: theme.spacing(2),
    // borderStyle: 'solid',
    // border: '1px black',
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)',
    transition: 'transform .2s',
    '&:hover': {
      transform: 'scale(1.03)',
    },
  },
  threeOptionHeader: {
    textAlign: 'center',
  },
  threeOptionItemContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // flexDirection: 'column',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  threeOptionsColumn: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    maxWidth: '300px',
    margin: theme.spacing(2),
  },
  threeOptionZoom: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(5),
  },
  link: {
    textDecoration: 'none',
    color: theme.palette.blue,
  },
  sectionText: {
    marginBottom: theme.spacing(2),
    // textAlign: 'center',
  },
  sectionHeader: {
    fontSize: '2.125rem',
    textAlign: 'center',
    textTransform: 'uppercase',
    letterSpacing: '3px',
  },
  header: {
    fontSize: '1.25rem',
    textTransform: 'uppercase',
    letterSpacing: '3px',
  },
  padTop: {
    marginTop: '16px',
  },
});

function ThreeOptionsSection(props) {
  const { classes } = props;
  return (
    <div className={classes.section}>
      <div className={classes.content}>
        <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">Nia... So Much More Than Movement</Typography>
        <Grid container>
          {/* Health + Wellness */}
          <Grid item xs={12} md={4} className={classes.threeOptionItemContainer}>
            <Zoom>
              <div className={classes.threeOptionsColumn}>
                <Typography className={classes.header} variant="h3" color="textSecondary">Our Commitments</Typography>
                <a target="_blank" rel="noopener noreferrer" href="/dei">
                  <img className={classes.icon} alt="Members of the Nia community during a synchronized somatic yoga online class" src={HealthImg} loading="lazy" />
                </a>
                <Typography className={classes.sectionText} color="textSecondary">Nia stands for every body - every age, size, shape, gender, ability, race and ethnicity, nationality, sexual orientation, faith, belief system and all of the other qualities that make each body and spirit unique. Learn more about our commitments <Link to="/dei" className={classes.link}>here</Link>.</Typography>
                <Button href="/dei" variant="outlined" color="secondary">More</Button>
              </div>
            </Zoom>
          </Grid>
          {/* Training */}
          <Grid item xs={12} md={4} className={classes.threeOptionItemContainer}>
            <Zoom>
              <div className={classes.threeOptionsColumn}>
                <Typography className={classes.header} variant="h3" color="textSecondary">TRAINING</Typography>
                <Link to="/finder/training">
                  <img className={classes.icon} alt="Members of Nia inviting people to try Nia’s mind body fitness classes" src={MembershipImg} loading="lazy" />
                </Link>
                <Typography className={classes.sectionText} color="textSecondary">Experience the power of Nia BODY + LIFE Trainings to cultivate joy, pleasure, health and well-being. Trainings online and in-person.</Typography>
                <Button href="/finder/training" target="_blank" className={classes.threeOptionButton} variant="outlined" color="secondary">Find a Training</Button>
              </div>
            </Zoom>
          </Grid>
          {/* Community */}
          <Grid item xs={12} md={4} className={classes.threeOptionItemContainer}>
            <Zoom>
              <div className={classes.threeOptionsColumn}>
                <Typography className={classes.header} variant="h3" color="textSecondary">Community</Typography>
                <a target="_blank" rel="noopener noreferrer" href="https://facebook.com/NiaTechnique">
                  <img className={classes.icon} alt="Nia community members laying down during one of Nia’s mind body fitness classes" src={CommunityImg} loading="lazy" />
                </a>
                <Typography className={classes.sectionText} color="textSecondary">Discover a global community of like-minded individuals committed to the path of well-being, personal growth and healthy living for body, mind and soul. Follow us on <a rel="noopener noreferrer" href="https://facebook.com/NiaTechnique" className={classes.link} target="_blank">Facebook</a> and <a rel="noopener noreferrer" href="https://instagram.com/niatechnique" className={classes.link} target="_blank">Instagram</a>.</Typography>
                <Button className={classes.padTop} target="_blank" href="https://facebook.com/NiaTechnique" variant="outlined" color="secondary">More</Button>
              </div>
            </Zoom>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

ThreeOptionsSection.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ThreeOptionsSection);
